module.exports = "https://trybtryb-legacy.web.app/img/how-make-money-desktop.b1104671.webp";